module.exports = __webpack_public_path__ + "img/img02_text.5c3d0501.png";